<div class="cookie-shell" *ngIf="bannerVisible" role="region" aria-label="Cookie consent">
  <div class="cookie-banner">
    <button type="button" class="cookie-close" aria-label="Close cookie message" (click)="dismissBanner()">×</button>

    <div class="cookie-copy">
      <span class="cookie-kicker">YOUR PRIVACY</span>
      <h2>We use cookies</h2>
      <p>
        We use necessary cookies to keep this website secure and working. With your permission,
        optional analytics cookies may also be used to understand how visitors use the site and
        improve the experience.
      </p>
      <a routerLink="/cookie-notice" class="cookie-notice-link">Read our Cookie Notice</a>
    </div>

    <div class="cookie-actions" aria-label="Cookie choices">
      <button type="button" class="cookie-btn cookie-btn-outline" (click)="openSettings()">Cookie Settings</button>
      <button type="button" class="cookie-btn cookie-btn-text" (click)="rejectNonEssential()">Reject non-essential</button>
      <button type="button" class="cookie-btn cookie-btn-primary" (click)="allowAll()">Allow all</button>
    </div>
  </div>
</div>

<div class="cookie-modal-backdrop" *ngIf="settingsVisible" (click)="closeSettings()" aria-hidden="true"></div>

<section class="cookie-settings" *ngIf="settingsVisible" role="dialog" aria-modal="true" aria-labelledby="cookie-settings-title">
  <div class="cookie-settings-header">
    <div>
      <span class="cookie-kicker">PRIVACY PREFERENCES</span>
      <h2 id="cookie-settings-title">Cookie Settings</h2>
    </div>
    <button type="button" class="cookie-close cookie-close-dark" aria-label="Close cookie settings" (click)="closeSettings()">×</button>
  </div>

  <p class="cookie-settings-intro">
    Choose which optional technologies may be used. Strictly necessary technologies are required
    for the website to operate and cannot be switched off.
  </p>

  <div class="cookie-category cookie-category-required">
    <div class="cookie-category-copy">
      <h3>Strictly necessary</h3>
      <p>Required for core website operation, security and session continuity.</p>
    </div>
    <span class="cookie-status">Always active</span>
  </div>

  <div class="cookie-category">
    <div class="cookie-category-copy">
      <h3>Analytics</h3>
      <p>
        Allows optional analytics technologies to measure website usage and help improve content and performance.
        No analytics script is loaded by this component itself.
      </p>
    </div>

    <label class="cookie-switch">
      <input type="checkbox" [(ngModel)]="analyticsEnabled" aria-label="Allow analytics cookies">
      <span class="cookie-slider" aria-hidden="true"></span>
    </label>
  </div>

  <p class="cookie-settings-note">
    You can change this choice at any time using <strong>Cookie Settings</strong> in the footer.
  </p>

  <div class="cookie-settings-actions">
    <button type="button" class="cookie-btn cookie-btn-secondary" (click)="rejectNonEssential()">Reject non-essential</button>
    <button type="button" class="cookie-btn cookie-btn-outline-dark" (click)="savePreferences()">Save preferences</button>
    <button type="button" class="cookie-btn cookie-btn-primary" (click)="allowAll()">Allow all</button>
  </div>
</section>
